import { WrappedFieldProps } from 'redux-form';
import classNames from 'classnames';
import React from 'react';

export const SelectField = ({
  input,
  meta,
  labelText,
  options,
  disabled,
}: WrappedFieldProps & {
  labelText: string;
  options: Array<{ value: string; label: string }>;
  disabled: boolean;
}) => (
  <div className={classNames('input input-label', { 'input-error': meta.touched && meta.invalid })}>
    <label>{labelText}</label>
    <select {...input} disabled={disabled}>
      <option value="">Sélectionner...</option>
      {options.map(({ value, label }) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </select>
    {meta.touched && meta.error && <div className="error-message">{meta.error}</div>}
  </div>
);
